import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ChevronDown } from "lucide-react";

export const NO_STAGE = "__none__";

export function StageFilter({ testid, options, value, onChange }) {
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  const all = [...options, NO_STAGE];
  const label = value.length === 0 ? "All" : value.length === 1 ? (value[0] === NO_STAGE ? "No stage" : value[0]) : `${value.length} selected`;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid={testid} className="input-slim !py-0.5 !px-1.5 !text-[10px] w-full flex items-center justify-between gap-1 text-left">
          <span className="truncate">{label}</span><ChevronDown className="w-3 h-3 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-56 p-2 text-xs">
        {all.map((v) => (
          <label key={v} className="flex items-center gap-2 py-1 px-1 hover:bg-[var(--bg-subtle,#f5f5f0)] cursor-pointer">
            <input type="checkbox" data-testid={`${testid}-opt-${v.replace(/\s+/g, "-").toLowerCase()}`} checked={value.includes(v)} onChange={() => toggle(v)} />
            <span>{v === NO_STAGE ? "No stage" : v}</span>
          </label>
        ))}
        <div className="flex justify-between border-t mt-1 pt-1.5">
          <button data-testid={`${testid}-escalations`} className="underline" onClick={() => onChange(options.filter((o) => /Escalation/.test(o)))}>Escalations only</button>
          <button data-testid={`${testid}-clear`} className="underline" onClick={() => onChange([])}>Clear</button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
